module.exports = __webpack_public_path__ + "img/qrcode-zhiyi.017aed22.png";